import React from 'react';
import {
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import {
  ERClubBadge,
  LocationsAccordion,
} from 'views/rebranded-module/location-module/LocationsViewV2/components';
import useAccordionControl from 'views/rebranded-module/location-module/LocationsViewV2/hooks/useAccordionContol';
import StyledAccordion from 'views/rebranded-module/location-module/LocationsViewV2/components/DistrictLocationsAccordion/DistrictLocationsAccordion.styles';
import { Typography700 } from 'views/rebranded-module/common/components';

const DistrictLocationsAccordion = (props) => {
  const {
    district,
    membershipEnabled,
    isSearching,
    defaultVehicleType,
    content,
  } = props;
  const [expanded, handleAccordionChange] = useAccordionControl(isSearching);

  const renderLocation = (location) => (
    <NavigatorLink
      href={PATHS.locationSlug(location.slug)}
      key={location.id}
      data-testid={`locations-directory-link-${encodeURIComponent(
        location.name,
      )}`}>
      <Typography variant="body2" component="p" mb={0.75}>
        {location.name}
        {' '}
        {location.membership && membershipEnabled && (
          <ERClubBadge content={content} />
        )}
      </Typography>
    </NavigatorLink>
  );
  return (
    <StyledAccordion
      square
      expanded={expanded}
      onChange={handleAccordionChange}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className="DLAsummary">
        <NavigatorLink
          href={PATHS.geoSlug([
            defaultVehicleType.slug,
            district?.region?.slug,
          ])}
          key={district.region.name}>
          <Typography700 variant="h6" component="p">
            {district.region.name}
          </Typography700>
        </NavigatorLink>
      </AccordionSummary>
      <AccordionDetails>
        {district.markets?.map((market) => (market.id ? (
          <Box>
            <LocationsAccordion
              isSearching={expanded}
              market={market}
              key={market.id}
              membershipEnabled={membershipEnabled}
              defaultVehicleType={defaultVehicleType}
              content={content}
              />
          </Box>
        ) : (
          <Box>
            {market.locations.map((location) => renderLocation(location))}
          </Box>
        )))}
        {district.locations?.map((location) => renderLocation(location))}
      </AccordionDetails>
    </StyledAccordion>
  );
};

export { DistrictLocationsAccordion };
